import styles from "../styles/Services_temp.module.css";

function Services(props) {
  return (
    <div>
      <MainContainer />
    </div>
  );
}

function MainContainer() {
  return (
    <div className={styles.maincontainer}>
      <TitleDescription />
      <ServicesItemsRow />
    </div>
  );
}

function TitleDescription() {
  return (
    <div className={styles.titledescriptioncontainer}>
      <div className={styles.title}>Services </div>
      <div className={styles.description}>
        These are some of the services that I provide to my clients
      </div>
    </div>
  );
}

function ServicesItemsRow() {
  return (
    <div className={styles.allservices}>
      <ServiceItem />
      <ServiceItem />
      <ServiceItem />
    </div>
  );
}

function ServiceItem() {
  return (
    <div className={styles.servicecontainer}>
      <div className={styles.serviceitemline} />
      <div className={styles.servicenumtitlecontainer}>
        <div className={styles.serviceitemnum}>01</div>
        <div className={styles.serviceitemtitle}>UI UX Design</div>
      </div>
    </div>
  );
}

export default Services;
